exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-tag {\n    display: inline-block;\n    font-size: 90%;\n    padding: 0.4em;\n    font-weight: 700;\n    white-space: nowrap;\n    vertical-align: middle;\n    border-radius: 0.25rem;\n    margin-right: 0.25em;\n    margin-bottom: 0.25em;\n    cursor: pointer;\n    transition: opacity 0.3s;\n    text-align: center;\n    opacity: 0.85;\n    background-color: #73B3D4;\n    color: black;\n}\n.app-tag:hover {\n    opacity: 1;\n}\n.app-tag::after {\n    display: 'block';\n    content: '\\D7';\n    padding-left: 0.4em;\n    opacity: 0.5;\n    transition: opacity 0.3s;\n}\n.app-tag:hover::after {\n    opacity: 1;\n}\n@media (max-width: 425px) {\n    .app-tag {\n        position: relative;\n        text-align: left;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-right: 20px;\n   }\n    .app-tag::after {\n        position: absolute;\n        right: 0.4em;\n        top: 50%;\n        transform: translateY(-50%);\n   }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/tagsComponent/tag/tag.component.css
// module id = ../../../../../src/app/questions/tagsComponent/tag/tag.component.css
// module chunks = main